module.exports = __webpack_public_path__ + "Roboto-Light.ed4b08d2702fa26acc32.woff2";


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/src/assets/vendors/base/fonts/googleapi-fonts/Roboto-Light.woff2
// module id = ../../../../../src/assets/vendors/base/fonts/googleapi-fonts/Roboto-Light.woff2
// module chunks = styles